module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-800.863bd4ae.svg";